
import { Vue, Component } from "vue-property-decorator";
import InstructorArticle from "@/modules/instructor/components/InstructorArticle.vue";

@Component({
  components: { InstructorArticle },
})
export default class Instructor extends Vue {}
